<template>
  <vetster-slide-over
    ref="slideOver"
    container-classes="lg:!h-[350px]"
    :is-slidein="!$screen('lg')"
  >
    <template #header>
      <vetster-slide-over-common-heading
        :header="$t('search.what-are-prescription-service-fees')"
        @close="close"
      />
    </template>

    <template #content>
      <i18n
        :path="contentTranslationKey"
        tag="p"
        class="px-standard"
      >
        <template #percent>
          <span v-if="serviceFeesPercentage">
            {{ serviceFeesPercentageText }}
          </span>
        </template>
      </i18n>
    </template>

    <template #footer>
      <div class="w-full flex justify-end">
        <vetster-slide-over-common-footer
          :primary-action-label="$t('search.got-it')"
          @primary-action="close"
        />
      </div>
    </template>
  </vetster-slide-over>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonFooter from '@/brand-components/VetsterSlideOverCommonFooter';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';
import SubscriptionPlanCoverageType from '@/enums/SubscriptionPlanCoverageType';

export default {
  name: 'VetsterSubscriptionRelatedFeesSlideOver',

  components: {
    VetsterSlideOver,
    VetsterSlideOverCommonFooter,
    VetsterSlideOverCommonHeading,
  },

  computed: {
    ...mapGetters(['isEcommerceCapable']),
    ...mapGetters('subscriptionPlans', ['getYearlySubscriptionPlan']),

    contentTranslationKey() {
      return this.isEcommerceCapable
        ? 'search.when-ordering-prescriptions'
        : 'search.when-sending-prescriptions';
    },

    serviceFeesPercentage() {
      return (this.transferFeeBenefit?.coinsurance_percent || 0) * 100;
    },

    serviceFeesPercentageText() {
      return this.$t('search.with-vetster-plus-you-can-get', { percent: this.serviceFeesPercentage });
    },

    transferFeeBenefit() {
      return this.getYearlySubscriptionPlan?.benefits.find(
        (benefit) => benefit.coverage_type === SubscriptionPlanCoverageType.TransferFee,
      ) || null;
    },
  },

  methods: {
    close() {
      this.$refs.slideOver.close();
    },

    open() {
      this.$refs.slideOver.open();
    },
  },
};
</script>
